var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn",class:_vm.classic,on:{"click":e=>this.$emit('click',e)}},[(_vm.iconSide==='left')?_c('i',{class:_vm.icon}):_vm._e(),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.iconSide==='right')?_c('i',{class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }